import { createTranslations } from '@npco/common-utils-translations'

export const selfieVerificationLoaderTranslations = createTranslations({
  title: 'Setting up selfie check',
  description: 'Please make sure you are using a physical ID.',
})
